import React from "react";
import StudentAchievements from "./StudentAchievements/StudentAchievements";

export default function BadgesPage() {
  return <StudentAchievements />;
}